import {Component} from '../../core';
import {CoworkFilterComponent} from './cowork-filter.component'
import {CoworkDynamicContactComponent} from './cowork-dynamic-contact.component'; 
import {CoworkFeaturedSpacesComponent} from './cowork-featured-spaces.component';
import {CoworkHomeSearchComponent} from './cowork-home-search.component'
import {isEmpty,getterSetter,replaceSpace,connectionCheck} from '../../utils/common';
import {getLoggedInUser} from '../../loginService'
import {adServicesInit} from '../../services/adServices'
import {addPageView} from './coworkga';
import {getCookie,setCookie} from '../../services/cookieService'
import './coworkga';


/**
 * Cowork SNB component
 */
export class CoworkSnbComponent extends Component {

    constructor(el) {
        super(el);
    }

    onComponentLoaded() {
        getLoggedInUser.then((result) => {
            if(result && result.data && result.data.user){
                getterSetter.set( 'loginData', result);
                getterSetter.set( 'loginstatus', true);
            }else{
                getterSetter.set( 'loginstatus', false);
            }
            return true;
        });

        // Initialize the filters
        this.initializeFilters();

        this.initializeContactsEvent();

        this.initializeFeaturedSpaces();

        // Initialize the search box
        this.initializeSearchBox();

        if(connectionCheck()){
            adServicesInit();
            var targetNode = document.getElementById('coworksnb_1');
            if(targetNode){
               if(targetNode.children){
                    if(document.getElementById('mHeaderAPI')){
                        document.getElementById('mHeaderAPI').classList.add('dfp_slot')
                    }
                    if(document.getElementById('dHeaderAPI')){
                        document.getElementById('dHeaderAPI').classList.add('dfp_slot')
                    }
                }
            }
        }

        // Initialize page view
        this.initializePageView();
    }

    /**
     * Initializes  page view
     */
    initializePageView() {
        let url = '';
        if ((window.location.href).indexOf('text') !== -1) {
            url = '/search?catname=QH_CoWork';
        }else {
            url = '//SnB_type=browse?catname=QH_CoWork';
        }
         var city = getCookie('new_prefer_city');
        let locality = globals.localityName;
        if(!isEmpty(city)){
            url += '&City='+replaceSpace(city);
        }
        if(!isEmpty(locality)){
            url += '&Locality='+replaceSpace(locality);
        }
        url += ',v72=True';
        addPageView(url);
    }

    /**
     * Initializes the featured spaces
     */
    initializeFeaturedSpaces(){
        if(globals.mobile != "1") { 
            const featuredSpaces = new CoworkFeaturedSpacesComponent();
        }   
    }

     /**
     * Initializes the search box
     */
    initializeSearchBox() {
         const searchComponent = new CoworkHomeSearchComponent();
    }

    initializeFilters() {
        let coworkfilters = JSON.parse(atob(globals.coworkFilters));
        const  filters = new CoworkFilterComponent(null, {
                filter: coworkfilters
            });
    }

    initializeContactsEvent() {
        
        var classname = document.getElementsByClassName("enquiryinit");
        Array.from(classname).forEach((element) => {
          element.addEventListener('click', this.initializeContactFormWithPropertyId.bind(this));
        });
    }

    initializeContactFormWithPropertyId(ev) {
        document.getElementById('co_workEnquiryPopup').innerHTML = '';
        // Initialize the contact form
        this.fetchContact().then((response) => {
            document.getElementById('co_workEnquiryPopup').innerHTML = response;
            let propertyId = ev.target.getAttribute("data-ref-id");
            let propertyDetail = ev.target.getAttribute("data-ref-leaddetail");
            if(document.getElementById('contactDynamicFormId')) {
                document.getElementById('contactDynamicFormId').setAttribute('data-component', 'cowork-dynamic-contact' + propertyId);
            }
            const contactComponent = new CoworkDynamicContactComponent(null, {propertyId, propertyDetail});
        });
    }

    fetchContact() {
        return fetch(`/homes/re2/coworkcontact?aj=1`).then((res) => res.text());
    }
    
}
